<script setup lang="ts">
interface Props {
  last?: boolean
  first?: boolean
  desktop?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  last: false,
  first: false,
  desktop: false,
})

const classList = computed(() => {
  return {
    'separated-item_last': props.last,
    'separated-item_first': props.first,
    'separated-item_desktop': props.desktop,
  }
})
</script>

<template>
  <div class="separated-item" :class="classList">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.separated-item {
  padding: 12px 0;
  border-bottom: 1px solid $ui-gray-2;

  &_desktop {
    padding: 16px 0;
  }

  &_last {
    border-bottom: none;
  }

  &_first {
    padding-top: 0;
    border-top: none;
  }

  &:last-child {
    border-bottom: none;
  }
}
</style>
